import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { resolveAssetUrl } from "../baseurl";

export default function HeroBanner({ content }) {
  const videoRef = useRef(null);
  const video = resolveAssetUrl(content?.heroVideo) || "";

  useEffect(() => {
    const videoElement = videoRef.current;

    if (!videoElement || !video) return;

    videoElement.load();

    videoElement.play().catch(() => {
      
    });
  }, [video]);

  return (
    <section
      className="relative w-full overflow-hidden flex items-center justify-center text-center z-0 pt-[160px] pr-[clamp(24px,5vw,80px)] pb-[70px] pl-[clamp(24px,5vw,80px)] min-h-[720px]"
    >
      <video
  ref={videoRef}
  src={video}
  autoPlay
  loop
  muted
  playsInline
  preload="auto"
  poster="/videos/hero-poster.jpg"
  className="absolute inset-0 w-full h-full object-cover z-0"
/>

      <div className="absolute inset-0 bg-black/40 z-10" />

      <div className="relative flex flex-col items-center z-20">
        <h1 className="text-white font-semibold text-[60px]">
          {content?.heroTitle || "Futura Bio Labs"}
        </h1>

        <p className="text-gray-300 text-[20px] mt-[24px] mb-[16px]">
          {content?.heroDescription || "Premium Peptides. Great Prices. Fast Shipping."}
        </p>

        <Link to='/shop'>
        <button className="gold-glow-btn bg-white text-black rounded-full hover:bg-gray-200 transition px-[28px] py-[11px] text-[17px] mt-[10px]">
           {content?.heroButtonText || "ENTER THE LAB"}
        </button>
        </Link>
      </div>
    </section>
  );
}